<template>
  <div class="settingCookies" v-if="showPopup">
    <dl class="settingCookies__dl">
      <dt>{{ showMessage.title }}</dt>
      <dd v-html="showMessage.message"></dd>
    </dl>
    <div v-if="!showDetail" class="settingCookies__box">
      <label><input type="button" class="allow" :value="showMessage.allowAll" @click="onEnterAll(true)"></label>
      <label><input type="button" class="disallow" :value="showMessage.disallow" @click="onEnterAll(false)"></label>
      <span @click="showDetail = true">{{ showMessage.openDescription }}</span>
    </div>
    <div v-if="showDetail" class="settingCookies__description">
      <div class="settingCookies__box one">
        <label class="checkbox" v-for="(item, index) in showMessage.tags" :key="index">
          <input type="checkbox" v-model="item.enable">
          {{ item.name }}
        </label>
        <div class="settingCookies__box two">
          <label><input type="button" class="allow" :value="showMessage.allow" @click="onEnterCookie()"></label>
          <span @click="showDetail = false">{{ showMessage.closeDescription }}</span>
        </div>
      </div>
      <p>{{ showMessage.description }}</p>
    </div>
  </div>
</template>

<script>
import CookieUtil from './CookieUtil'
import { eventBus } from '../eventBus';
export default {
  props: {
    lang: {
      default: 'th',
      type: String,
      require : true,
    }
  },
  data() {
    return {
      gtag: 'BNNH8SCJYK',
      showPopup: false,
      showDetail: false,
      showMessage: {},
      setMessage: [{
        ja: {
          title: 'Cookieの許可',
          message: '当社のウェブサイトの不可欠な部分としてCookieを使用しています<br><a href="/privacy/">プライバシーポリシーを見る</a>',
          allow: '許可する',
          allowAll: '全て許可する',
          disallow: '全て許可しない',
          openDescription: '詳細を開く',
          closeDescription: '詳細を閉じる',
          description: 'ウェブサイトは、主にクッキーの形で、ブラウザに情報を保存または取得する場合があります。この情報は、エクスペリエンスをパーソナライズするために使用され、通常はIDにリンクされていません。特定の種類のCookieを許可しないことを選択できますが、Webサイトのエクスペリエンスに影響を与える可能性があります。さまざまなカテゴリをクリックして、詳細を確認し、設定を変更します',
          tags: [
            { name: '解析用クッキー', key: 'analysis', enable: false },
            { name: '広告用クッキー', key: 'marketing', enable: false },
          ]
        },
        en: {
          title: 'Cookie Consent',
          message: 'We use cookies that are essential for the proper functioning of our website.<br><a href="/privacy/">View Privacy Policy</a>',
          allow: 'Accept',
          allowAll: 'Accept All Cookies',
          disallow: 'Reject All Cookies',
          openDescription: 'Show Details',
          closeDescription: 'Hide Details',
          description: 'This website may store or retrieve information on your browser, mostly in the form of cookies. This information is used to personalize your experience and is typically not linked directly to your identity. You may choose not to allow certain types of cookies, but this could affect your site experience. You can review and change your preferences by clicking on the different cookie categories.',
          tags: [
            { name: 'Performance Cookies', key: 'analysis', enable: false },
          ]
        },
        th: {
          title: 'การยินยอมให้ใช้คุกกี้',
          message: 'เราใช้คุกกี้ที่จำเป็นต่อการทำงานอย่างถูกต้องของเว็บไซต์ของเรา<br><a href="/privacy/">ดูนโยบายความเป็นส่วนตัว</a>',
          allow: 'ยอมรับ',
          allowAll: 'ยอมรับคุกกี้ทั้งหมด',
          disallow: 'ปฏิเสธคุกกี้ทั้งหมด',
          openDescription: 'แสดงรายละเอียด',
          closeDescription: 'ซ่อนรายละเอียด',
          description: 'เว็บไซต์นี้อาจจัดเก็บหรือเรียกข้อมูลจากเบราว์เซอร์ของคุณ ซึ่งส่วนใหญ่จะอยู่ในรูปแบบของคุกกี้ ข้อมูลนี้ใช้เพื่อปรับประสบการณ์ของคุณให้เหมาะสม และโดยทั่วไปจะไม่เชื่อมโยงกับตัวตนของคุณโดยตรง คุณสามารถเลือกไม่อนุญาตคุกกี้บางประเภทได้ แต่อาจส่งผลต่อประสบการณ์การใช้งานเว็บไซต์ของคุณ คุณสามารถตรวจสอบและเปลี่ยนแปลงการตั้งค่าของคุณได้โดยคลิกที่ประเภทคุกกี้ต่าง ๆ',
          tags: [
            { name: 'คุกกี้เพื่อวิเคราะห์ประสิทธิภาพ', key: 'analysis', enable: false },
          ]
        }
      }]
    }
  },
  methods: {
    onEnterAll(bool = false){
      this.showMessage.tags.forEach(el => {
        if(bool){
          el.enable = true
        }else{
          el.enable = false
        }
      })
      this.onEnterCookie()
    },
    onEnterCookie(){
      this.showMessage.tags.forEach(el => {
        if(el.enable){
          this.onSetCookie(el.key)
        }else{
          CookieUtil.remove(el.key)
          if(el.key == 'analysis'){
            this.onGaDelete()
          }
          if(el.key == 'marketing'){
            this.onMkDelete()
          }
        }
      })
      this.closePopUp()
    },
    onSetCookie(str, bool = true){
      if(bool){
        CookieUtil.set(str, 'enabled')
      }
      switch(str){
        case 'analysis':
          this.loadGtagScript()
          break
        case 'marketing':
          this.loadMarketingScript()
          break
        default:
          break
      }
    },
    onDefault(){
      this.showMessage.tags.forEach(el => {
        if(CookieUtil.get(el.key) == 'enabled'){
          el.enable = true
          this.onSetCookie(el.key, false)
        }
      })
    },

    onGaDelete(){
      CookieUtil.remove(`_ga_${this.gtag}`)
      CookieUtil.remove('_ga')
    },

    onMkDelete(){
    },

    closePopUp(){
      CookieUtil.set('popup', 'enabled')
      this.showPopup = false
    },

    loadGtagScript() {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=G-${this.gtag}`
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || []
        function gtag(){ dataLayer.push(arguments) }
        window.gtag = gtag; // 明示的に window に貼る

        gtag('js', new Date())
        gtag('config', `G-${this.gtag}`)
      }
    },

    loadMarketingScript(){

    }
  },
  mounted() {
    this.showMessage = this.setMessage[0][this.lang];
    // 初回表示
    if(CookieUtil.get('popup') !== 'enabled'){
      this.showPopup = true
    }
    this.onDefault();
    eventBus.on('open-cookie-popup', () => {
      this.showPopup = true
    });

  },
}



</script>

<style lang="scss">
.settingCookies{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  padding: 1rem;
  border-radius: .4rem;
  background: module.$white;
  box-shadow: .64rem .64rem 2.4rem rgba(module.$normal,.24);
  z-index: 9999;
  max-width: 32rem;
  @media screen and (max-width: module.$phone){
    max-width: calc(100% - 2rem);
  }
  &__dl{
    font-size: .92rem;
    dt{
      font-size: 1.12rem;
      font-weight: 700;
    }
  }
  a{
    color: module.$main;
    text-decoration: underline;
  }
  &__box{
    display: grid;
    grid-template-columns: repeat(2, auto) 1fr;
    gap: .8rem;
    margin: .8rem 0 0;
    @media screen and (max-width: module.$phone){
      grid-template-columns: repeat(2, 1fr);
    }
    &.two{
      grid-template-columns: repeat(2, 1fr);
    }
    &.one{
      grid-template-columns: repeat(1, 1fr);
      gap: .8rem;
      margin: 0 0 1.6rem;
    }
    > * {
      align-self: center;
    }
    > label{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      input[type=button]{
        @include module.font();
        background: module.$border;
        padding: .72rem .8rem;
        line-height: 1;
        border: none;
        border-radius: .24rem;
        @media screen and (max-width: module.$phone){
          width: 100%;
        }
        cursor: pointer;
        &.allow{
          background: module.$sub;
          color: module.$white;
        }
        &:hover{
          opacity: .8;
        }
      }
      &.checkbox{
        background: module.$border;
        padding: .72rem .8rem;
      }
      input[type=checkbox]{
        margin: 0 .4rem 0 0;
        display: inline-block;
      }
    }
    > span{
      text-align: end;
      text-decoration: underline;
      align-self: flex-end;
      cursor: pointer;
      @media screen and (max-width: module.$phone){
        text-align: start;
      }
    }
  }
  &__description{
    font-size: .92rem;
    margin: 1.6rem 0 0;
    padding: 1.6rem 0 0;
    border-top: module.$border 1px solid;
    p{
      margin: 1.6rem 0 0;
    }
  }
}
</style>
